import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { PapiDaSharedUserFriendsBirthdays } from '@wix/da-papi-types';

export const initialize = createAction(
  `${actionTypePrefix}/INITIALIZE`,
  () => ({})
);

export const requestSuccess = createAction(
  `${actionTypePrefix}/REQUEST_SUCCESS`,
  (data: PapiDaSharedUserFriendsBirthdays) => ({
    data,
  })
);

export const requestFailure = createAction(
  `${actionTypePrefix}/REQUEST_FAILURE`,
  () => ({})
);
